$(document).ready(function () {
  $(".custom_atc_button").click(function () {
    var currentId = $(this).attr("data-id");
    var mode = $(this).attr("data");
    var sellingPlanId = $(this).attr("data-sub-id");
    var quantityCur = $(this).closest(".formCont").find(".gf_pq_qty").val();

    console.log(mode, "MODE");

    if (mode == "sub") {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
              selling_plan: sellingPlanId,
            },
            success: function () {
              window.location.href = "/checkout";
            },
          });
        },
      });
    } else {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
            },
            success: function () {
              window.location.href = "/checkout";
            },
          });
        },
      });
    }
  });

  $(".custom_atc_button_cart").click(function () {
    var currentId = $(this).attr("data-id");
    var mode = $(this).attr("data");
    var sellingPlanId = $(this).attr("data-sub-id");
    var quantityCur = $(this).closest(".formCont").find(".gf_pq_qty").val();

    console.log(mode, "MODE");

    if (mode == "sub") {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
              selling_plan: sellingPlanId,
            },
            success: function () {},
          });
        },
      });
    } else {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
            },
            success: function () {},
          });
        },
      });
    }
  });

  $(".product_tab-block").click(function () {
    $(this).toggleClass("active");
    $(this).find(".product_tab-content").slideToggle();
  });

  $(".main_product-btn").click(function () {
    $(".nutrition_popup-outer").hide();
  });

  $(".nutrition_popup-outer").click(function () {
    $(".nutrition_popup-outer").hide();
  });

  $(".main_product-nutrition-info").click(function () {
    $(".nutrition_popup-outer").css("display", "flex");
  });

  $(".product-inside_block").click(function () {
    $(this).toggleClass("active");
    $(this).find(".product-inside_block-content").slideToggle();
  });

  $(".product_faq-box").click(function () {
    $(this).toggleClass("active");
    $(this).find(".product_faq-content").slideToggle();
  });

  $(".product_carousel-prev").click(function () {
    $(this)
      .closest(".product_carousel-outer")
      .find(".slick-prev")
      .trigger("click");
  });

  $(".product_carousel-next").click(function () {
    $(this)
      .closest(".product_carousel-outer")
      .find(".slick-next")
      .trigger("click");
  });

  $(document).on("click", ".product_ugc-video", function () {
    const video = $(this).find("video").get(0);
    const playOverlay = $(this).find(".product_ugc-play");

    // If this video is already playing, pause it and show play button
    if (video && !video.paused && !video.ended) {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
      playOverlay.show();
      return;
    }

    // Otherwise: pause all videos, reset them, and play the clicked one
    $(".product_ugc-play").show();
    $(".product_ugc-container video").each(function () {
      this.pause();
      this.currentTime = 0;
      this.muted = true;
    });

    if (video) {
      video.muted = false;
      video.currentTime = 0;
      video.play();
      playOverlay.hide();
    }
  });

  $(".product-lymph-ingredient").click(function () {
    $(this).find(".product_lymph-ingr-content").slideToggle();
  });

  $(".product_primary-btn.scrolling").click(function (evt) {
    evt.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".main_product-container").offset().top - 100,
      },
      500
    );
  });

  function getBusinessDayFromToday(offsetDays) {
    let date = new Date();
    let addedDays = 0;

    while (addedDays < offsetDays) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        // 0 = Sunday, 6 = Saturday
        addedDays++;
      }
    }

    return date;
  }

  function formatDate(date) {
    const weekday = date.toLocaleDateString(undefined, { weekday: "long" });
    const day = date.getDate();
    const month = date.toLocaleDateString(undefined, { month: "long" });
    return `${weekday}, ${day} ${month}`;
  }

  const targetDate = getBusinessDayFromToday(3);
  const formattedDate = formatDate(targetDate);
  $(".col_pp_delivery__Date").text(formattedDate);


  // var $span = $('.pdp_selector-title-timer span');
  // var TZ = 'America/New_York';

  // function getTZParts(d) {
  //   var parts = new Intl.DateTimeFormat('en-US', {
  //     timeZone: TZ,
  //     year: 'numeric',
  //     month: 'numeric',
  //     day: 'numeric',
  //     hour: 'numeric',
  //     minute: 'numeric',
  //     second: 'numeric',
  //     hour12: false
  //   }).formatToParts(d).reduce(function (acc, p) {
  //     acc[p.type] = p.value;
  //     return acc;
  //   }, {});
  //   return {
  //     y: +parts.year,
  //     m: +parts.month,
  //     d: +parts.day,
  //     h: +parts.hour,
  //     min: +parts.minute,
  //     s: +parts.second
  //   };
  // }

  // function update() {
  //   var now = new Date();
  //   var p = getTZParts(now);

  //   // current time in target TZ as UTC ms
  //   var nowMs = Date.UTC(p.y, p.m - 1, p.d, p.h, p.min, p.s);

  //   // next midnight in target TZ as UTC ms
  //   var nextMidnightMs = Date.UTC(p.y, p.m - 1, p.d + 1, 0, 0, 0);

  //   var diff = Math.max(0, nextMidnightMs - nowMs);
  //   var hrs = Math.floor(diff / 3600000);
  //   var mins = Math.floor((diff % 3600000) / 60000);
  //   var secs = Math.floor((diff % 60000) / 1000);

  //   $span.text(
  //     String(hrs).padStart(2, '0') + ':' +
  //     String(mins).padStart(2, '0') + ':' +
  //     String(secs).padStart(2, '0')
  //   );
  // }

  // update();
  // setInterval(update, 1000);


// var $span = $('.pdp_selector-title-timer span');
// var TZ = 'America/New_York';

// function getTZParts(d) {
//   var parts = new Intl.DateTimeFormat('en-US', {
//     timeZone: TZ,
//     year: 'numeric',
//     month: 'numeric',
//     day: 'numeric',
//     hour: 'numeric',
//     minute: 'numeric',
//     second: 'numeric',
//     hour12: false
//   }).formatToParts(d).reduce(function (acc, p) {
//     acc[p.type] = p.value;
//     return acc;
//   }, {});

//   return {
//     y: +parts.year,
//     m: +parts.month,
//     d: +parts.day,
//     h: +parts.hour,
//     min: +parts.minute,
//     s: +parts.second
//   };
// }

// function update() {
//   var now = new Date();
//   var p = getTZParts(now);

//   // current time in ms (in target timezone)
//   var nowMs = Date.UTC(p.y, p.m - 1, p.d, p.h, p.min, p.s);

//   // Determine the 3-hour block we are in
//   var currentBlockHour = Math.floor(p.h / 3) * 3;

//   // Next block start time (every 3 hours)
//   var nextBlockMs = Date.UTC(p.y, p.m - 1, p.d, currentBlockHour + 3, 0, 0);

//   // If it's the last block of the day (21–24h), roll over to next day
//   if (currentBlockHour + 3 >= 24) {
//     nextBlockMs = Date.UTC(p.y, p.m - 1, p.d + 1, 0, 0, 0);
//   }

//   var diff = Math.max(0, nextBlockMs - nowMs);

//   var hrs = Math.floor(diff / 3600000);
//   var mins = Math.floor((diff % 3600000) / 60000);
//   var secs = Math.floor((diff % 60000) / 1000);

//   $span.text(
//     String(hrs).padStart(2, '0') + ':' +
//     String(mins).padStart(2, '0') + ':' +
//     String(secs).padStart(2, '0')
//   );
// }

// update();
// setInterval(update, 1000);

var $span = $('.pdp_selector-title-timer span');
var TZ = 'America/New_York';

function getTZParts(d) {
  var parts = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
  }).formatToParts(d).reduce(function (acc, p) {
    acc[p.type] = p.value;
    return acc;
  }, {});

  return {
    y: +parts.year,
    m: +parts.month,
    d: +parts.day,
    h: +parts.hour,
    min: +parts.minute,
    s: +parts.second
  };
}

function update() {
  var now = new Date();
  var p = getTZParts(now);

  // Current NY time in ms
  var nowMs = Date.UTC(p.y, p.m - 1, p.d, p.h, p.min, p.s);

  // ---------------------------------------------------
  // 1️⃣ FINAL END TIME — TODAY AT 23:59:59 (NY TIME)
  // ---------------------------------------------------
  var finalDate = new Date('2025-11-28T23:59:59');
  var endParts = getTZParts(finalDate);
  var finalEndMs = Date.UTC(endParts.y, endParts.m - 1, endParts.d, endParts.h, endParts.min, endParts.s);

  // ---------------------------------------------------
  // STOP COMPLETELY AFTER FINAL DATE
  // ---------------------------------------------------
  if (nowMs >= finalEndMs) {
    $span.text("00:00:00");
    $('.pdp_selector-title-timer').css("display", "none"); // HIDE STRIP
    return;
  }

  // ---------------------------------------------------
  // 2️⃣ NEXT 3-HOUR CYCLE
  // ---------------------------------------------------
  var currentBlockHour = Math.floor(p.h / 3) * 3; // ex: 0,3,6,9,12…
  var nextBlockHour = currentBlockHour + 3;

  var nextBlockMs;

  if (nextBlockHour >= 24) {
    nextBlockMs = Date.UTC(p.y, p.m - 1, p.d + 1, 0, 0, 0);
  } else {
    nextBlockMs = Date.UTC(p.y, p.m - 1, p.d, nextBlockHour, 0, 0);
  }

  // ---------------------------------------------------
  // 3️⃣ PICK EARLIEST: 3hr cycle OR final date
  // ---------------------------------------------------
  var targetMs = Math.min(nextBlockMs, finalEndMs);

  var diff = targetMs - nowMs;

  var hrs = Math.floor(diff / 3600000);
  var mins = Math.floor((diff % 3600000) / 60000);
  var secs = Math.floor((diff % 60000) / 1000);

  $span.text(
    String(hrs).padStart(2, '0') + ':' +
    String(mins).padStart(2, '0') + ':' +
    String(secs).padStart(2, '0')
  );
}

// start
update();
setInterval(update, 1000);







  $(".home_banner-reviews").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });

  $(".main_product-image-carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: ".main_product-image-carousel_thumbs",
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin_1.png?v=1752126281'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin.png?v=1752126281'/></button>",
  });

  $(".main_product-image-carousel_thumbs").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    asNavFor: ".main_product-image-carousel",
  });

  $(".product_ugc-container").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin_1.png?v=1752126281'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin.png?v=1752126281'/></button>",
    responsive: [
      {
        breakpoint: 677,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".product_review-container").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    allowTouchMove: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin_1.png?v=1752126281'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin.png?v=1752126281'/></button>",
    responsive: [
      {
        breakpoint: 677,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
